import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  items: [], // Array of car IDs in wishlist
  status: 'idle',
  error: null,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    addToWishlist(state, action) {
      const carId = action.payload;
      if (!state.items.includes(carId)) {
        state.items.push(carId);
      }
    },
    removeFromWishlist(state, action) {
      const carId = action.payload;
      state.items = state.items.filter(id => id !== carId);
    },
    toggleWishlist(state, action) {
      const carId = action.payload;
      if (state.items.includes(carId)) {
        state.items = state.items.filter(id => id !== carId);
      } else {
        state.items.push(carId);
      }
    },
    setWishlist(state, action) {
      state.items = action.payload;
    },
    clearWishlist(state) {
      state.items = [];
    },
  },
});

export const { 
  addToWishlist, 
  removeFromWishlist, 
  toggleWishlist, 
  setWishlist, 
  clearWishlist 
} = wishlistSlice.actions;

export default wishlistSlice.reducer;

